import { useState } from 'react'

export const useCopyClipboard = (timeout: number = 1000) => {
	const [isCopied, setIsCopied] = useState(false)

	const copyToClipboard = (value: any) => {
		navigator.clipboard.writeText(value as string)

		setIsCopied(true)

		setTimeout(() => {
			setIsCopied(false)
		}, timeout)
	}

	return {
		isCopied,
		copyToClipboard,
	}
}
